export default "__VITE_ASSET__9d0bccd8__"